import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import * as styles from './ComparisonNotificationContainer.css';
import { trackClickPopup, trackPopupLimit } from './tracking';
import { NOTIFICATION_EXPIRATION_DELAY } from '../../../constants/offersComparison';
import { ComparisonNotification } from '../../components/ComparisonNotification';
import {
  ClearComparisonNotificationType,
  EComparisonNotificationCategory,
  IComparisonNotification,
} from '../../state/offersComparison';

interface IComparisonNotificationContainerProps {
  notification: IComparisonNotification;
}

const ComparisonNotificationContainer: React.FC<IComparisonNotificationContainerProps> = ({ notification }) => {
  const [timeoutId, setNotificationTimeout] = React.useState<ReturnType<typeof setTimeout> | null>(null);
  const dispatch = useDispatch();

  const { category, offerId, url, text } = notification;

  const isLimitNotification = React.useMemo(
    () => category === ('limit' as EComparisonNotificationCategory) || false,
    [category],
  );

  React.useEffect(() => {
    if (isLimitNotification && offerId) {
      trackPopupLimit({ offerId });
    }

    setNotificationTimeout(
      setTimeout(() => {
        dispatch({
          type: ClearComparisonNotificationType,
        });
      }, NOTIFICATION_EXPIRATION_DELAY),
    );

    return () => {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }, [notification]);

  const handleLinkClick = React.useCallback(() => {
    trackClickPopup({ offerId, category });

    setNotificationTimeout(
      setTimeout(() => {
        dispatch({
          type: ClearComparisonNotificationType,
        });
      }, NOTIFICATION_EXPIRATION_DELAY),
    );
  }, [offerId, category, dispatch]);

  const handleClose = React.useCallback(() => {
    dispatch({
      type: ClearComparisonNotificationType,
    });
  }, [dispatch]);

  const handleMouseEnter = React.useCallback(() => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);

  const control = url ? (
    <UIHeading5 color="text-inverted-default">
      <a href={url} className={styles['link']} onClick={handleLinkClick} target="_blank" rel="noreferrer">
        Перейти
      </a>
    </UIHeading5>
  ) : (
    <UIHeading5 color="text-inverted-default">
      <button onClick={handleClose} className={styles['button']}>
        Понятно
      </button>
    </UIHeading5>
  );

  if (text.length === 0) {
    return null;
  }

  return <ComparisonNotification control={control} text={text} onMouseEnter={handleMouseEnter} />;
};

// eslint-disable-next-line import/no-default-export
export default ComparisonNotificationContainer;
